import script from "./crm-dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./crm-dashboard.vue?vue&type=script&setup=true&lang=js"

import "./crm-dashboard.vue?vue&type=style&index=0&id=1d67d5d6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d67d5d6"]])

export default __exports__